import { DESKTOP_NAVBAR_WRAPPER_CLASS_NAME } from '../../constants/mui-components';

const MuiAppBar = {
  styleOverrides: {
    root: {
      [`&.${DESKTOP_NAVBAR_WRAPPER_CLASS_NAME}`]: {
        backgroundColor: 'transparent',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        position: 'fixed',
        boxShadow: 'none',
      },
    },
  },
};

export default MuiAppBar;
